<style lang="less">
  @import './login.less';
</style>

<template>
  <div class="login">
     <div class="login-con">
      <Card icon="log-in" title="商铺管理系统" :bordered="false">
        <div class="form-con">
          <login-form @on-success-valid="handleSubmit"></login-form>
          <!--<p class="login-tip"></p>-->
        </div>
      </Card>
    </div>
     <p class="copyright">© 2019 Changchengshangpu.com 版权所有 <a href="http://beian.miit.gov.cn" target="_blank" style="color: inherit;">蜀ICP备16036479号-3</a></p>
  </div>
</template>

<script>
import LoginForm from '_c/login-form'
import apiLogin from '@/api/login.js';
import apiMenu from '@/api/menu.js';
//import {  mapActions} from 'vuex'
export default {
  data(){
    return{

    }
  },
  components: {
    LoginForm
  },
  methods: {
//    ...mapActions([
//      'handleLogin',
//      'getUserInfo'
//    ]),
    handleSubmit ({ userName, password }) {
      this.toLogin(userName,password);
    },
    toLogin(userName,password){
      let _this = this;
      apiLogin.login(userName, password).then((_data) => {
        if (_data.data.LoginSuccess && _data.data.ExeSuccess) {
          _this.$Message.success('登录成功');
          let requestResult = _data.data.Data;
          sessionStorage.setItem("token",requestResult.Token);
          sessionStorage.setItem("name",requestResult.Name);
          sessionStorage.setItem("role",requestResult.RoleName);
          apiMenu.getUserMenu().then((_data) => {
            if(_data.data.LoginSuccess && _data.data.ExeSuccess){
              sessionStorage.setItem("menu",JSON.stringify(_data.data.Data));
              _this.$router.push({
                name: 'home'
              });
            }else {
              _this.$Message.error(_data.data.Msg);
            }
          })
        }else {
          _this.$Message.error(_data.data.Msg);
        }

      })
    }
  }
}
</script>

<style>

</style>
